<template lang="html">
	<div class="rs-order-overview">
		<div class="row">
			<div class="col">
				<div>
					Startzeit: {{ startDate | date }}
				</div>
				<div>
					Endzeit: {{ endDate | date }}
				</div>
			</div>
			<div class="col">
				<div v-if="pickUpBranch">Abholung: {{ pickUpBranch.name }}</div>
				<div v-if="returnBranch">Rückgabe: {{ returnBranch.name }}</div>
			</div>
			<div class="col">
				<div v-if="total">
					Gesamtpreis: <span class="price">{{ total | euro }}</span> <loader-icon 
						v-if="loadingPrice" 
						class="rs-loader" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import { LoaderIcon } from 'vue-feather-icons'
import moment from 'moment'

export default {
	name: 'OrderOverview',
	components: {
		LoaderIcon
	},
	computed: {
		...mapState('order', [
			'loadingPrice',
			'startDate',
			'endDate',
			'total',
			'pickUpBranch',
			'returnBranch'
		])
	}
}
</script>

<style lang="css">
.price{
	font-weight: bold;
}
.rs-order-overview{
    border-top: solid black 2px;
    border-bottom: solid black 2px;
    padding: 10px 0;
    margin: 30px 0;
}
@keyframes spin {
	from {transform: rotate(0deg);}
	to {transform: rotate(360deg);}
}
.rs-loader{
	height: 1em;
	animation: spin 3s linear infinite;
}
</style>
